import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { loginUserRequest } from "../redux/actions";
import { acceptCustomerInviteRequest, clearHeadNurseMessage, invitedCustomerDataClear, invitedCustomerDataRequest } from "../redux/actions/headNurse";
import { AppState } from "../redux/types";
import { ROLE } from "../utils/constants";
import FormContainer from "./FormContainer";
import SignupForm from "./SignupForm";
import SuccessModal from "./successModal/SuccessModal";
import { localePath } from "../i18n/config";

const RegisterCustomerViaEmailForm = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [token, setToken] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const headNurse = useSelector((state: AppState) => state.headNurse);
    const { data: invitedCustomerData, loading } = useSelector((state: AppState) => state.headNurse?.invitedCustomerData);
    const user = useSelector((state: AppState) => state.user);

    const [regData, setRegData] = useState({ email: "", password: "" });

    function useQuery() {
        const { search } = useLocation();
        return useMemo(() => new URLSearchParams(search), [search]);
    }
    let query = useQuery();

    useEffect(() => {
        let token = query.get("token");

        if (token) {
            setToken(token);
        } else {
            history.push(localePath("kirjaudu"));
        }
    }, [query, location, history]);

    const handleCreateAccount = (data: any) => {
        const _data = {
            ...data,
            role: "customer",
            token: token,
        };
        setRegData(_data);

        dispatch(acceptCustomerInviteRequest(_data));
    };

    useEffect(() => {
        if (headNurse.message?.status === 200 && regData) {
            dispatch(loginUserRequest(regData?.email, regData?.password, "invite", history));
            dispatch(invitedCustomerDataClear());
        }
    }, [headNurse.message, regData, dispatch, history]);

    useEffect(() => {
        if (user.role === ROLE.CUSTOMER_SMALL && user.isLoggedIn) {
            setShowSuccessModal(true);
        }
    }, [user]);

    useEffect(() => {
        if (token) {
            dispatch(invitedCustomerDataRequest(token));
        }
    }, [dispatch, token]);

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        dispatch(clearHeadNurseMessage());
    };
    return (
        <div>
            <h1 className="user-form-header col-md-3 text-center">Asiakas</h1> {/* Customer */}
            <FormContainer>
                <h3 className="user-form-header">Luo tili</h3> {/* Create an account */}
                {!loading && <SignupForm onCreateAccount={handleCreateAccount} initialData={invitedCustomerData} />}
            </FormContainer>
            <SuccessModal
                show={showSuccessModal}
                onHide={handleCloseSuccessModal}
                title="Tili luotu onnistuneesti!"
                message={"Asiakastili on luotu onnistuneesti!"}
                subMessage="Sinut ohjataan kirjautumissivulle automaattisesti..."
                redirectPath={localePath("tili", "laheinen")}
                redirectButtonText="Siirry kirjautumaan"
                autoRedirect={true}
                redirectDelay={3000}
            />
        </div>
    );
};

export default RegisterCustomerViaEmailForm;
